// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useLocation } from "react-router-dom";
export function useUrlParams() {
    var _a = useLocation().pathname.split("/"), type = _a[1], id = _a[2];
    var ids = {
        election_event_id: type === "sequent_backend_election_event" ? id : undefined,
        election_id: type === "sequent_backend_election" ? id : undefined,
        contest_id: type === "sequent_backend_contest" ? id : undefined,
        candidate_id: type === "sequent_backend_candidate" ? id : undefined,
    };
    return ids;
}
